import { Component, computed, inject } from '@angular/core';
import { iaIconCircleXmark, iaIconPlugsHbpro, iaIconPlugsNhb } from '@bcef/ia-icons';
import { IconComponent, provideIcons } from '@bcef/ia-ng-icons';
import { ContextService } from '@bcef/ia-shared';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'ia-report-technical-problem-error',
  imports: [IconComponent, TranslatePipe],
  template: `
    <div
      class="tw-flex tw-w-full tw-place-items-center tw-bg-white hbpro:tw-space-y-6 nhb:tw-space-y-2 mb-group:tw-p-12.5 hb-group:tw-mx-auto hb-group:tw-flex-col hb-group:tw-py-0 hb-group:tw-text-center max-sm:tw-flex-col  max-sm:tw-space-y-5 max-sm:tw-py-7.5 mb-group:max-sm:tw-px-5 mb-group:sm:tw-space-x-7.5 hb-group:sm:tw-w-1/2"
    >
      <ia-icons
        [name]="icon()"
        class="mb-group:tw-size-12.5 mb-group:tw-text-engineering-orange hb-group:tw-size-20"
      />
      <div class="tw-space-y-2.5 hbpro:tw-space-y-4">
        <p
          class="tw-text-mb-lg tw-font-bold hbpro:tw-text-hb-lg hbpro:tw-text-midnight-green nhb:tw-text-[24px] hb-group:tw-font-medium"
        >
          {{ 'screens.error.panel.content.title' | translate }}
        </p>
        <p
          class="tw-text-base hbpro:tw-text-hb-base hbpro:tw-font-normal hbpro:tw-text-slate-gray-2 nhb:tw-text-hb-md"
        >
          {{ 'screens.error.panel.content.subtitle' | translate }}
        </p>
      </div>
    </div>
    <a
      [href]="
        (context.isMobile
          ? 'screens.confirmation.link.mobile'
          : 'screens.confirmation.link.desktop'
        ) | translate
      "
      class="tw-w-fit tw-self-center tw-rounded-3xl tw-px-7 tw-py-2 tw-text-white hbpro:tw-rounded-2xl  hbpro:tw-bg-[#089ec4] hbpro:tw-px-5 hbpro:hover:tw-bg-deep-cerulean nhb:tw-rounded-[18px] nhb:tw-bg-button-primary nhb:tw-px-8 nhb:tw-text-button-primary-text hover:nhb:tw-bg-button-primary-hover mb-group:tw-bg-button-primary mb-group:tw-text-base mb-group:tw-font-semibold mb-group:hover:tw-bg-button-primary-hover hb-group:tw-py-3 hb-group:tw-font-medium mb-group:max-sm:tw-w-4/5 mb-group:sm:tw-self-end"
    >
      {{ 'screens.error.panel.content.retry' | translate }}
    </a>
  `,
  providers: [provideIcons(iaIconCircleXmark, iaIconPlugsHbpro, iaIconPlugsNhb)],
  host: {
    class: 'tw-flex tw-flex-col tw-space-y-5 hb-group:tw-space-y-8',
  },
})
export class ErrorComponent {
  protected readonly context = inject(ContextService);

  protected icon = computed(() => {
    if (this.context.isNhb) {
      return iaIconPlugsNhb.name;
    } else if (this.context.isHbPro) {
      return iaIconPlugsHbpro.name;
    } else {
      return iaIconCircleXmark.name;
    }
  });
}
